/**
 * @flow
 */

import React from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

// Getters
import * as getters from '../../modules/locale/getters';

type State = AnyMap

type Props = {
  intl: IntlShape;
  locale: string;
  messages: Object;
  children: AnyMap;
}
;

class IntlSwapper extends React.Component<void, Props, State> {
  render() {
    return (
      <IntlProvider messages={this.props.messages} locale={this.props.locale}>
        {this.props.children}
      </IntlProvider>
    );
  }
}

export function mapStateToProps(state: Object) {
  return {
    locale: getters.locale(state),
    messages: getters.messages(state)
  };
}

export default connect(mapStateToProps)(IntlSwapper);



// WEBPACK FOOTER //
// ./src/components/intl-swapper/index.js